/**
 * Formatea segundos a una etiqueta legible compacta:
 *   0.08    -> "80 ms"
 *   3.5     -> "3.5 s"
 *   45      -> "45 s"
 *   180     -> "3 min"
 *   3700    -> "1.0 h"
 *   86500   -> "1.0 d"
 *
 * Pensado para etiquetas de eje y tooltips de latencia.
 */
export function formatDuration(s) {
  if (s == null || isNaN(s)) return '—';
  if (s < 1) return `${Math.round(s * 1000)} ms`;
  if (s < 60) return `${s < 10 ? s.toFixed(1) : Math.round(s)} s`;
  const m = s / 60;
  if (m < 60) return `${m < 10 ? m.toFixed(1) : Math.round(m)} min`;
  const h = m / 60;
  if (h < 24) return `${h.toFixed(1)} h`;
  const d = h / 24;
  return `${d.toFixed(1)} d`;
}

export function formatNumber(n, opts = {}) {
  if (n == null || isNaN(n)) return '—';
  const { decimals = 0 } = opts;
  return Number(n).toLocaleString('es-CL', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

export function formatPct(rate) {
  if (rate == null || isNaN(rate)) return '—';
  return `${(rate * 100).toFixed(1)}%`;
}

/**
 * Calcula la duración en minutos de la ventana retornada por el endpoint
 * (objeto { from, to, source }). Devuelve null si no se puede parsear.
 */
export function windowDurationMinutes(windowObj) {
  if (!windowObj || !windowObj.from || !windowObj.to) return null;
  const fromMs = Date.parse(windowObj.from);
  const toMs = Date.parse(windowObj.to);
  if (isNaN(fromMs) || isNaN(toMs) || toMs <= fromMs) return null;
  return (toMs - fromMs) / 60000;
}
